import React from "react";
import {
  List,
  ListItemButton,
  ListItemText,
  ListSubheader,
  Paper,
} from "@mui/material";
import ChevronRightRounded from "@mui/icons-material/ChevronRightRounded";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";

import { fonts, tForLang } from "../AccountUtils";

/* -------------------------- URL tab helper -------------------------- */
const useTab = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  return params.get("tab") || "dashboard";
};

const changeTab = (navigate, tab) => {
  navigate({ search: `?tab=${tab}` }, { replace: false });
};

/* ------------------------------ Sidebar ----------------------------- */
export default function Sidebar({ lang }) {
  const navigate = useNavigate();
  const tab = useTab();
  const label = (key) => tForLang(lang, key);

  const item = (value, labelKey, onClick) => (
    <ListItemButton
      selected={tab === value}
      onClick={onClick}
      sx={{
        borderRadius: 1.5,
        mb: 0.75,
        "&.Mui-selected": { bgcolor: "grey.100" },
      }}
    >
      <ListItemText
        primaryTypographyProps={{ fontFamily: fonts[lang], fontWeight: 700 }}
        primary={label(labelKey)}
      />
      <ChevronRightRounded />
    </ListItemButton>
  );

  return (
    <Paper elevation={0} sx={{ p: 2, position: "sticky", top: 84 }}>
      <List
        subheader={
          <ListSubheader
            disableSticky
            sx={{
              fontFamily: fonts[lang],
              fontWeight: 900,
              bgcolor: "transparent",
              px: 0,
              pb: 1,
            }}
          />
        }
        sx={{ p: 0 }}
      >
        <ListItemButton
          component={RouterLink}
          to={"/profile"}
          sx={{ borderRadius: 1.5, mb: 0.75 }}
        >
          <ListItemText
            primary={label("memberArea")}
            primaryTypographyProps={{
              fontFamily: fonts[lang],
              fontWeight: 700,
            }}
          />
          <ChevronRightRounded />
        </ListItemButton>

        {item("basic", "basicInfo", () => changeTab(navigate, "basic"))}

        {/* <ListItemButton
          component={RouterLink}
          to={"/常見問題Q&A"}
          sx={{ borderRadius: 1.5, mb: 0.75 }}
        >
          <ListItemText
            primary={label("shoppingGuide")}
            primaryTypographyProps={{ fontFamily: fonts[lang], fontWeight: 700 }}
          />
          <ChevronRightRounded />
        </ListItemButton> */}

        <ListItemButton
          component={RouterLink}
          to={"/詢價/歷史"}
          sx={{ borderRadius: 1.5, mb: 0.75 }}
        >
          <ListItemText
            primary={label("quickInquiryHistory")}
            primaryTypographyProps={{
              fontFamily: fonts[lang],
              fontWeight: 700,
            }}
          />
          <ChevronRightRounded />
        </ListItemButton>

        <ListItemButton
          component={RouterLink}
          to={"/線上報修"}
          sx={{ borderRadius: 1.5, mb: 0.75 }}
        >
          <ListItemText
            primary={label("quickRetail")}
            primaryTypographyProps={{
              fontFamily: fonts[lang],
              fontWeight: 700,
            }}
          />
          <ChevronRightRounded />
        </ListItemButton>
      </List>
    </Paper>
  );
}
